<template>
  <Modal
    ref="modal"
    :title="'Request Funds'"
  >
    <template #modal-main>
      <!-- <div class="modal-form scrollbar"> -->
      <form class="modal-form form container" @submit.prevent="handleSubmit">
        <div class="row mt-3">
          <div class="col-12 form__control-group">
            <label class="required" for="contact-form-subject">Requested Amount</label>
            <input
              id="contact-form-subject"
              v-model="formData.amount"
              type="text"
              class="form-input"
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 form__control-group">
            <label class="required" for="form_create-org">Message</label>
            <textarea
              id="form_create-org"
              v-model="formData.message"
              type="text"
              placeholder="Hi, I am working on a vehicle detection solution and would like to request additional funds."
              rows="5"
              class="form-input"
            />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <button
              id="request-funds-send-email-btn"
              type="submit"
              class="button"
              :class="{'button-spinner': isLoading}"
              :disabled="isLoading ? true : false"
            >
              Send
            </button>
          </div>
        </div>
      </form>
      <!-- </div> -->
    </template>
  </Modal>
</template>

<script setup>
import { ref } from 'vue';
import Modal from '@/components/Modal.vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { useToast } from 'vue-toast-notification';

const $toast = useToast();

const modal = ref(null);
function showModal() {
  modal.value?.showModal();
}
function closeModal() {
  modal.value?.closeModal();
}
defineExpose({
  showModal, closeModal,
});

const isLoading = ref(false);

const formData = ref({
  amount: '',
  message: '',
});

async function handleSubmit() {
  // Check if required fields are filled
  const {
    amount, message,
  } = formData.value;

  // List of required fields to check
  const requiredFields = {
    amount, message,
  };
  const missingFields = Object.keys(requiredFields).filter((field) => !requiredFields[field]);

  if (missingFields.length > 0) {
    $toast.open({
      queue: true,
      duration: 5000,
      message: `Please fill in the following fields: ${missingFields.join(', ')}`,
      type: 'error',
      position: 'top',
    });
    return;
  }

  isLoading.value = true;
  const dataConnect = new DatastoreConnect();
  await dataConnect.userRequestFunds({ ...formData.value })
    .then((resp) => {
      if (resp.error !== undefined) {
        throw Error(resp.error.message);
      }

      $toast.open({
        queue: true,
        duration: 5000,
        message: "Request sent. Our team will reach out to you shortly.",
        type: 'success',
        position: 'top',
      });
      closeModal();
      isLoading.value = false;
    })
    .catch((error) => {
      $toast.open({
        queue: true,
        duration: 5000,
        message: error,
        type: 'error',
        position: 'top',
      });
      isLoading.value = false;
    });
}

</script>

<style lang="scss" scoped>
.modal-form {
  width: 800px;
  padding: 10px 80px 40px 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-height: fit-content;
  min-height: fit-content;
  margin: auto;
  @include themify() {
    color: themed('body-text-color');
  }

  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 10;
    margin-bottom: 10px;

    h1 {
      margin-top: 10px;
      text-align: center;
      font-size: 24px;
    }
  }
}

@media (max-width: $breakpoint-sm) {
  .modal-form {
    padding: 32px;
  }
}
@media (max-width: $breakpoint-md) {
  .modal-form {
    width: 100%;
  }
}

#request-funds-send-email-btn {
  width: 100%;
  border-radius: 8px;
}
</style>
